import React, { createContext, useContext, useMemo } from 'react';
import { useSendUnlayerEmail } from '@/components/Drawers/AddUnlayerEmailDrawer/hooks/useSendUnlayerEmail';

const UnlayerSendContext = createContext(null);

/**
 * Owns send-error state and the Formik submit handler for the compose drawer.
 */
export const UnlayerSendProvider = ({ children }) => {
	const { clearSendError, handleSubmit, sendError } = useSendUnlayerEmail();

	const value = useMemo(
		() => ({
			clearSendError,
			handleSubmit,
			sendError,
		}),
		[clearSendError, handleSubmit, sendError],
	);

	return <UnlayerSendContext.Provider value={value}>{children}</UnlayerSendContext.Provider>;
};

export const useUnlayerSendContext = () => {
	const context = useContext(UnlayerSendContext);
	if (!context) {
		throw new Error('useUnlayerSendContext must be used within an UnlayerSendProvider');
	}
	return context;
};
